<app-async-mat-icon-button
  title="Aperçu de l'avenant"
  ariaLabel="Aperçu de l'avenant"
  [action]="getPdf()"
  progress="bar"
  (actionResult)="onPdfLoaded($event)"
>
  <mat-icon class="info">picture_as_pdf</mat-icon>
</app-async-mat-icon-button>

@if (mayAbandon()) {
  <button
    mat-icon-button
    matTooltip="Abandonner l'avenant"
    aria-label="Abandonner l'avenant"
    (click)="abandon()"
  >
    <mat-icon class="error">delete</mat-icon>
  </button>
}

<app-button-cancel-validation-request [contract]="subject()"></app-button-cancel-validation-request>
@if (amendment().status === 'DRAFT' && !contractSigned()) {
  <span
    class="awaiting-contract"
    [matTooltip]="awaitingContractSignature"
    [attr.aria-label]="compact() ? awaitingContractSignature : null"
    tabindex="0"
  >
    <mat-icon aria-hidden="true">hourglass_empty</mat-icon>
    @if (!compact()) {
      Attend la signature du contrat
    }
  </span>
} @else {
  <app-button-request-validation
    [contract]="subject()"
    validationType="REX_VALIDATION"
  ></app-button-request-validation>
}
@for (validationType of validationRequestTypes; track $index) {
  <app-button-refuse-validation-request
    [contract]="subject()"
    [validationType]="validationType"
  ></app-button-refuse-validation-request>
  <app-button-accept-and-request-validation
    [contract]="subject()"
    [acceptValidationType]="validationType"
  ></app-button-accept-and-request-validation>
}
<app-button-accept-validation-request
  [contract]="subject()"
  validationType="DRH_VALIDATION"
></app-button-accept-validation-request>

@if (amendment().status === 'SIGNING') {
  <app-upload-document-button
    [allowedTypes]="acceptedMimeTypes"
    [multiple]="false"
    tooltip="Téléverser l'avenant signé"
    (uploaded)="onSignedDocumentUploaded($event[0].id)"
  >
    <fa-icon class="signature" [icon]="faSignature"></fa-icon>
  </app-upload-document-button>
  <app-yousign-button
    class="warning"
    [action]="requestYousignSignature()"
    (actionResult)="onYousignSignatureRequested()"
    [signatureRequests]="amendment().signatureRequests"
    ariaLabel="Demander la signature Yousign de l'avenant"
    *appHasRole="requestYousignSignatureRoles"
  ></app-yousign-button>
}
